import { useMutation } from "react-query";

export default function useVerifyEmailCode() {
  return useMutation({
    mutationFn: async ({
      email,
      emailCode,
    }: {
      email: string;
      emailCode: string;
    }) => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/verify-email-code`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            emailCode,
          }),
        },
      );

      if (!response.ok) throw new Error("Network response was not ok");

      return response.json();
    },
  });
}
